// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1593":"6493fa5c","5081":"d9a39b03"}[chunkId] + ".chunk.css";
};